import { CALL_API, Schemas } from '../store/api';

export const LISTING_REQUEST = 'LISTING_REQUEST';
export const LISTING_SUCCESS = 'LISTING_SUCCESS';
export const LISTING_FAILURE = 'LISTING_FAILURE';
export const LISTING_UPDATE_FILTERS = 'LISTING_UPDATE_FILTERS';
export const LISTING_CLEAR_FILTERS = 'LISTING_CLEAR_FILTERS';
export const LISTING_COUNT_REQUEST = 'LISTING_COUNT_REQUEST';
export const LISTING_COUNT_SUCCESS = 'LISTING_COUNT_SUCCESS';
export const LISTING_COUNT_FAILURE = 'LISTING_COUNT_FAILURE';
export const VIOLATIONS_COUNT_REQUEST = 'VIOLATIONS_COUNT_REQUEST';
export const VIOLATIONS_COUNT_SUCCESS = 'VIOLATIONS_COUNT_SUCCESS';
export const VIOLATIONS_COUNT_FAILURE = 'VIOLATIONS_COUNT_FAILURE';
export const VIOLATED_LIST_REQUEST = 'VIOLATED_LIST_REQUEST';
export const VIOLATED_LIST_SUCCESS = 'VIOLATED_LIST_SUCCESS';
export const VIOLATED_LIST_FAILURE = 'VIOLATED_LIST_FAILURE';
export const LISTING_IMAGES_REQUEST = 'LISTING_IMAGES_REQUEST';
export const LISTING_IMAGES_SUCCESS = 'LISTING_IMAGES_SUCCESS';
export const LISTING_IMAGES_FAILURE = 'LISTING_IMAGES_FAILURE';
export const VIOLATION_TYPES_REQUEST = 'VIOLATION_TYPES_REQUEST';
export const VIOLATION_TYPES_SUCCESS = 'VIOLATION_TYPES_SUCCESS';
export const VIOLATION_TYPES_FAILURE = 'VIOLATION_TYPES_FAILURE';
export const LISTING_DETAIL_REQUEST = 'LISTING_DETAIL_REQUEST';
export const LISTING_DETAIL_SUCCESS = 'LISTING_DETAIL_SUCCESS';
export const LISTING_DETAIL_FAILURE = 'LISTING_DETAIL_FAILURE';
export const FHAKEYWORDS_REQUEST = 'FHAKEYWORDS_REQUEST';
export const FHAKEYWORDS_SUCCESS = 'FHAKEYWORDS_SUCCESS';
export const FHAKEYWORDS_FAILURE = 'FHAKEYWORDS_FAILURE';
export const REMOVE_VIOLATION_REQUEST = 'REMOVE_VIOLATION_REQUEST';
export const REMOVE_VIOLATION_SUCCESS = 'REMOVE_VIOLATION_SUCCESS';
export const REMOVE_VIOLATION_FAILURE = 'REMOVE_VIOLATION_FAILURE';
export const ADD_FHAKEYWORD_REQUEST = 'ADD_FHAKEYWORD_REQUEST';
export const ADD_FHAKEYWORD_SUCCESS = 'ADD_FHAKEYWORD_SUCCESS';
export const ADD_FHAKEYWORD_FAILURE = 'ADD_FHAKEYWORD_FAILURE';
export const DELETE_FHAKEYWORD_REQUEST = 'DELETE_FHAKEYWORD_REQUEST';
export const DELETE_FHAKEYWORD_SUCCESS = 'DELETE_FHAKEYWORD_SUCCESS';
export const DELETE_FHAKEYWORD_FAILURE = 'DELETE_FHAKEYWORD_FAILURE';
export const CORRECTED_LISTING_REQUEST = 'CORRECTED_LISTING_REQUEST';
export const CORRECTED_LISTING_SUCCESS = 'CORRECTED_LISTING_SUCCESS';
export const CORRECTED_LISTING_FAILURE = 'CORRECTED_LISTING_FAILURE';
export const UPDATE_EXTRA = 'UPDATE_EXTRA';
export const CLEAR_EXTRA = 'CLEAR_EXTRA';
export const NON_APPROVED_NOTIFICATIONS_REQUEST = 'NON_APPROVED_NOTIFICATIONS_REQUEST';
export const NON_APPROVED_NOTIFICATIONS_SUCCESS = 'NON_APPROVED_NOTIFICATIONS_SUCCESS';
export const NON_APPROVED_NOTIFICATIONS_FAILURE = 'NON_APPROVED_NOTIFICATIONS_FAILURE';
export const APPROVE_NOTIFICATION_REQUEST = 'APPROVE_NOTIFICATION_REQUEST';
export const APPROVE_NOTIFICATION_SUCCESS = 'APPROVE_NOTIFICATION_SUCCESS';
export const APPROVE_NOTIFICATION_FAILURE = 'APPROVE_NOTIFICATION_FAILURE';
export const BROKER_OVERRIDE_LIST_REQUEST = 'BROKER_OVERRIDE_LIST_REQUEST';
export const BROKER_OVERRIDE_LIST_SUCCESS = 'BROKER_OVERRIDE_LIST_SUCCESS';
export const BROKER_OVERRIDE_LIST_FAILURE = 'BROKER_OVERRIDE_LIST_FAILURE';
export const ADD_BROKER_OVERRIDE_REQUEST = 'ADD_BROKER_OVERRIDE_REQUEST';
export const ADD_BROKER_OVERRIDE_SUCCESS = 'ADD_BROKER_OVERRIDE_SUCCESS';
export const ADD_BROKER_OVERRIDE_FAILURE = 'ADD_BROKER_OVERRIDE_FAILURE';
export const EDIT_BROKER_OVERRIDE_REQUEST = 'EDIT_BROKER_OVERRIDE_REQUEST';
export const EDIT_BROKER_OVERRIDE_SUCCESS = 'EDIT_BROKER_OVERRIDE_SUCCESS';
export const EDIT_BROKER_OVERRIDE_FAILURE = 'EDIT_BROKER_OVERRIDE_FAILURE';
export const DELETE_BROKER_OVERRIDE_REQUEST = 'DELETE_BROKER_OVERRIDE_REQUEST';
export const DELETE_BROKER_OVERRIDE_SUCCESS = 'DELETE_BROKER_OVERRIDE_SUCCESS';
export const DELETE_BROKER_OVERRIDE_FAILURE = 'DELETE_BROKER_OVERRIDE_FAILURE';
export const BROKER_OVERRIDE_COMPANIES_REQUEST = 'BROKER_OVERRIDE_COMPANIES_REQUEST';
export const BROKER_OVERRIDE_COMPANIES_SUCCESS = 'BROKER_OVERRIDE_COMPANIES_SUCCESS';
export const BROKER_OVERRIDE_COMPANIES_FAILURE = 'BROKER_OVERRIDE_COMPANIES_FAILURE';
export const BROKER_OVERRIDE_BROKERS_REQUEST = 'BROKER_OVERRIDE_BROKERS_REQUEST';
export const BROKER_OVERRIDE_BROKERS_SUCCESS = 'BROKER_OVERRIDE_BROKERS_SUCCESS';
export const BROKER_OVERRIDE_BROKERS_FAILURE = 'BROKER_OVERRIDE_BROKERS_FAILURE';
export const FHA_TO_WARNING_REQUEST = 'FHA_TO_WARNING_REQUEST';
export const FHA_TO_WARNING_SUCCESS = 'FHA_TO_WARNING_SUCCESS';
export const FHA_TO_WARNING_FAILURE = 'FHA_TO_WARNING_FAILURE';
export const PERSONAL_INFO_WHITE_LIST_REQUEST = 'PERSONAL_INFO_WHITE_LIST_REQUEST';
export const PERSONAL_INFO_WHITE_LIST_SUCCESS = 'PERSONAL_INFO_WHITE_LIST_SUCCESS';
export const PERSONAL_INFO_WHITE_LIST_FAILURE = 'PERSONAL_INFO_WHITE_LIST_FAILURE';
export const ADD_PERSONAL_INFO_WHITE_LIST_REQUEST = 'ADD_PERSONAL_INFO_WHITE_LIST_REQUEST';
export const ADD_PERSONAL_INFO_WHITE_LIST_SUCCESS = 'ADD_PERSONAL_INFO_WHITE_LIST_SUCCESS';
export const ADD_PERSONAL_INFO_WHITE_LIST_FAILURE = 'ADD_PERSONAL_INFO_WHITE_LIST_FAILURE';
export const DELETE_PERSONAL_INFO_WHITE_LIST_REQUEST = 'DELETE_PERSONAL_INFO_WHITE_LIST_REQUEST';
export const DELETE_PERSONAL_INFO_WHITE_LIST_SUCCESS = 'DELETE_PERSONAL_INFO_WHITE_LIST_SUCCESS';
export const DELETE_PERSONAL_INFO_WHITE_LIST_FAILURE = 'DELETE_PERSONAL_INFO_WHITE_LIST_FAILURE';


/* export const fetchListings = () => (dispatch, getState) => {

    const { filters } = getState().listings;

    var lst = [];

    if(filters && filters.listingType === "new"){
        lst = [
            { id: 12345, agent: "John Bath", ldate: "3/1/2018", emailed: "Yes", status: "Active", violations: 1 },
            { id: 23456, agent: "Mark Down", ldate: "3/1/2018", emailed: "Yes", status: "Active", violations: 3 },
            { id: 34567, agent: "Steve Math", ldate: "3/3/2018", emailed: "Yes", status: "Active", violations: 4 },
            { id: 45678, agent: "Julia Jen", ldate: "3/3/2018", emailed: "Yes", status: "Active", violations: 1 },
            { id: 56789, agent: "Rock Zen", ldate: "3/5/2018", emailed: "Yes", status: "Active", violations: 2 },
            { id: 11345, agent: "Nath Lee", ldate: "3/1/2018", emailed: "Yes", status: "Active", violations: 1 },
            { id: 22456, agent: "Bravo Uno", ldate: "3/1/2018", emailed: "Yes", status: "Active", violations: 3 },
            { id: 33567, agent: "Martin Jack", ldate: "3/3/2018", emailed: "Yes", status: "Active", violations: 4 }          
        ].sort((a, b) => (b.ldate < a.ldate ? -1 : 1));
    }
    else{
        lst = [
            { id: 44678, agent: "Romi Nen", ldate: "3/3/2018", emailed: "Yes", status: "Active", violations: 1 },
            { id: 55789, agent: "Rocky Rath", ldate: "3/5/2018", emailed: "Yes", status: "Active", violations: 2 },
            { id: 13345, agent: "Adi Dash", ldate: "3/1/2018", emailed: "Yes", status: "Active", violations: 1 },
            { id: 23356, agent: "Michael Pit", ldate: "3/1/2018", emailed: "Yes", status: "Active", violations: 3 },
            { id: 33367, agent: "Petter Gul", ldate: "3/3/2018", emailed: "Yes", status: "Active", violations: 4 },
            { id: 53789, agent: "Alex Fan", ldate: "3/5/2018", emailed: "Yes", status: "Active", violations: 2 }
        ].sort((a, b) => (b.ldate < a.ldate ? -1 : 1));
    }    

    return dispatch({
        type: LISTING_SUCCESS, 
        response: { result: { Listings: lst} }
    });
}; */

export const fetchListings = (body) => ({
    [CALL_API]: {
        types: [LISTING_REQUEST, LISTING_SUCCESS, LISTING_FAILURE],
        method: 'POST',
        body: {
            ...body
        },
        endpoint: 'listings/getlistings',
        schema: Schemas.LISTING_ARRAY
    }
});

export const fetchListingCount = () => ({
    [CALL_API]: {
        types: [LISTING_COUNT_REQUEST, LISTING_COUNT_SUCCESS, LISTING_COUNT_FAILURE],
        method: 'GET',
        endpoint: 'listings/getactivelistingstats',
        schema: Schemas.LISTINGS_COUNT
    }
});

export const fetchViolationCount = (body) => ({
    [CALL_API]: {
        types: [VIOLATIONS_COUNT_REQUEST, VIOLATIONS_COUNT_SUCCESS, VIOLATIONS_COUNT_FAILURE],
        method: 'POST',
        body: {
            ...body
        },
        endpoint: 'listings/getlistingstats',
        schema: Schemas.VIOLATIONS
    }
});

export const fetchViolatedListings = (body) => ({
    [CALL_API]: {
        types: [VIOLATED_LIST_REQUEST, VIOLATED_LIST_SUCCESS, VIOLATED_LIST_FAILURE],
        method: 'POST',
        body: {
            ...body
        },
        endpoint: 'listings/getlistingstats/byday',
        schema: Schemas.VIOLATED_LISTING_ARRAY
    }
});

export const updateFilters = (params) => (dispatch, getState) => {
    return dispatch({type: LISTING_UPDATE_FILTERS, params: params });
}

export const clearFilters = () => (dispatch, getState) => {
    return dispatch({type: LISTING_CLEAR_FILTERS });
}

export const testStartFetching = () => (dispatch, getState) => {
    return dispatch({type: LISTING_REQUEST });
}

export const fetchListingImages = (body) => ({
    [CALL_API]: {
        types: [LISTING_IMAGES_REQUEST, LISTING_IMAGES_SUCCESS, LISTING_IMAGES_FAILURE],
        method: 'POST',
        body: {
            ...body
        },
        endpoint: 'listings/getlistings',
        schema: Schemas.LISTING_IMAGE_ARRAY
    }
});

export const fetchViolationTypes = () => ({
    [CALL_API]: {
        types: [VIOLATION_TYPES_REQUEST, VIOLATION_TYPES_SUCCESS, VIOLATION_TYPES_FAILURE],
        method: 'GET',
        endpoint: 'listings/getviolationtypes',
        schema: Schemas.VIOLATION_TYPE_ARRAY
    }
});

export const fetchListingDetails = (id) => ({
    [CALL_API]: {
        types: [LISTING_DETAIL_REQUEST, LISTING_DETAIL_SUCCESS, LISTING_DETAIL_FAILURE],
        method: 'GET',
        endpoint: 'listings/getlistingdetails/' + id
    }
});

export const fetchFHAKeywords = () => ({
    [CALL_API]: {
        types: [FHAKEYWORDS_REQUEST, FHAKEYWORDS_SUCCESS, FHAKEYWORDS_FAILURE],
        method: 'GET',
        endpoint: 'listings/getfhakeywords',
        schema: Schemas.FHAKEYWORD_ARRAY
    }
});

export const removeViolation = (id, body) => ({
    [CALL_API]: {
        types: [REMOVE_VIOLATION_REQUEST, REMOVE_VIOLATION_SUCCESS, REMOVE_VIOLATION_FAILURE],
        method: 'POST',
        body: {
            ...body
        },
        endpoint: 'listings/removeviolation/' + id
    }
});

export const addFHAKeyword = (body) => ({
    [CALL_API]: {
        types: [ADD_FHAKEYWORD_REQUEST, ADD_FHAKEYWORD_SUCCESS, ADD_FHAKEYWORD_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'listings/addfhakeyword'
    }
});

export const deleteFHAKeyword = (id) => ({
    [CALL_API]: {
        types: [DELETE_FHAKEYWORD_REQUEST, DELETE_FHAKEYWORD_SUCCESS, DELETE_FHAKEYWORD_FAILURE],
        method: 'DELETE',
        endpoint: 'listings/deletefhakeyword/' + id
    }
});

export const fetchCorrectedListings = (body) => ({
    [CALL_API]: {
        types: [CORRECTED_LISTING_REQUEST, CORRECTED_LISTING_SUCCESS, CORRECTED_LISTING_FAILURE],
        method: 'POST',
        body: {
            ...body
        },
        endpoint: 'listings/getcorrectedlistings',
        schema: Schemas.CORRECTED_LISTING_ARRAY
    }
});

export const updateExtra = (params) => (dispatch, getState) => {
    return dispatch({type: UPDATE_EXTRA, params: params });
}

export const clearExtra = () => (dispatch, getState) => {
    return dispatch({type: CLEAR_EXTRA });
}

export const fetchNonApprovedNotifications = (body) => ({
    [CALL_API]: {
        types: [NON_APPROVED_NOTIFICATIONS_REQUEST, NON_APPROVED_NOTIFICATIONS_SUCCESS, NON_APPROVED_NOTIFICATIONS_FAILURE],
        method: 'POST',
        body: {
            ...body
        },
        endpoint: 'listings/getnonapprovednotifications',
        schema: Schemas.NON_APPROVED_NOTIFICATION_ARRAY
    }
});

export const approveNotification = (id) => ({
    [CALL_API]: {
        types: [APPROVE_NOTIFICATION_REQUEST, APPROVE_NOTIFICATION_SUCCESS, APPROVE_NOTIFICATION_FAILURE],
        method: 'GET',
        endpoint: 'listings/approvenotification/' + id
    }
});

export const fetchBrokerOverrideList = () => ({
    [CALL_API]: {
        types: [BROKER_OVERRIDE_LIST_REQUEST, BROKER_OVERRIDE_LIST_SUCCESS, BROKER_OVERRIDE_LIST_FAILURE],
        method: 'GET',
        endpoint: 'listings/getbrokeremailmapper',
        schema: Schemas.BROKER_OVERRIDE_ARRAY
    }
});

export const fetchBrokerOverrideCompanies = (body) => ({
    [CALL_API]: {
        types: [BROKER_OVERRIDE_COMPANIES_REQUEST, BROKER_OVERRIDE_COMPANIES_SUCCESS, BROKER_OVERRIDE_COMPANIES_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'listings/getcompanylist',
        schema: Schemas.BROKER_OVERRIDE_COMPANY_ARRAY
    }
});

export const fetchBrokerOverrideBrokers = (ckey, body) => ({
    [CALL_API]: {
        types: [BROKER_OVERRIDE_BROKERS_REQUEST, BROKER_OVERRIDE_BROKERS_SUCCESS, BROKER_OVERRIDE_BROKERS_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'listings/getcompanybrokerlist/' + ckey,
        schema: Schemas.BROKER_OVERRIDE_BROKER_ARRAY
    }
});

export const addBrokerOverride = (body) => ({
    [CALL_API]: {
        types: [ADD_BROKER_OVERRIDE_REQUEST, ADD_BROKER_OVERRIDE_SUCCESS, ADD_BROKER_OVERRIDE_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'listings/addemailmapper'
    }
});

export const editBrokerOverride = (id, body) => ({
    [CALL_API]: {
        types: [EDIT_BROKER_OVERRIDE_REQUEST, EDIT_BROKER_OVERRIDE_SUCCESS, EDIT_BROKER_OVERRIDE_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'listings/updateemailmapper/' + id
    }
});

export const deleteBrokerOverride = (id) => ({
    [CALL_API]: {
        types: [DELETE_BROKER_OVERRIDE_REQUEST, DELETE_BROKER_OVERRIDE_SUCCESS, DELETE_BROKER_OVERRIDE_FAILURE],
        method: 'GET',
        endpoint: 'listings/deleteemailmapper/' + id
    }
});

export const convertFHAToWarning = (body) => ({
    [CALL_API]: {
        types: [FHA_TO_WARNING_REQUEST, FHA_TO_WARNING_SUCCESS, FHA_TO_WARNING_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'listings/convertfhatowarning'
    }
});

export const fetchPersonalInfoWhiteList = () => ({
    [CALL_API]: {
        types: [PERSONAL_INFO_WHITE_LIST_REQUEST, PERSONAL_INFO_WHITE_LIST_SUCCESS, PERSONAL_INFO_WHITE_LIST_FAILURE],
        method: 'GET',
        endpoint: 'listings/getpersonalinfoexceptions',
        schema: Schemas.PERSONAL_INFO_WHITE_LIST_ARRAY
    }
});

export const addPersonalInfoWhiteList = (body) => ({
    [CALL_API]: {
        types: [ADD_PERSONAL_INFO_WHITE_LIST_REQUEST, ADD_PERSONAL_INFO_WHITE_LIST_SUCCESS, ADD_PERSONAL_INFO_WHITE_LIST_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'listings/addpersonalinfoexception'
    }
});

export const deletePersonalInfoWhiteList = (id) => ({
    [CALL_API]: {
        types: [DELETE_PERSONAL_INFO_WHITE_LIST_REQUEST, DELETE_PERSONAL_INFO_WHITE_LIST_SUCCESS, DELETE_PERSONAL_INFO_WHITE_LIST_FAILURE],
        method: 'DELETE',
        endpoint: 'listings/deletepersonalinfoexception/' + id
    }
});